import React, { useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { VehiclesGroupsPricing } from 'components/VehiclesGroups';

const ChangePricingRulesModal = ({
  loading,
  steps,
  title,
  vehicleGroup,
  relatedRulesets,
  open,
  handleClick,
  fleet,
}) => {
  const [edit, setEdit] = useState(false);
  const [pricing, setPricing] = useState('');
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={title || i18n.t('pricing_rules.edit')}
    >
      <VehiclesGroupsPricing
        loading={loading}
        step={steps?.pricing}
        onSave={() => {}}
        currentGroup={vehicleGroup}
        pricingRulesets={relatedRulesets}
        edit={edit}
        setEdit={setEdit}
        pricing={pricing}
        setPricing={setPricing}
        fleet={fleet}
      />
    </BaseModal>
  );
};

ChangePricingRulesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangePricingRulesModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangePricingRulesModal;
